import SaveButton from 'components/buttons/SaveButton';
import SelectInput from 'components/input-field/SelectInput';
import TextInput from 'components/input-field/TextInput'
import { Form, Formik } from 'formik';
import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { Col, Row } from 'reactstrap';
import Loader from 'components/loader/Loader';
import TextAreaInput from 'components/input-field/TextAreaInput';
import CheckBox from 'components/input-field/CheckBox';
import { ModuleSchema } from './Validation';

class AddModuleForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            spiner: false,
            values: {
                module: '',
                description: '',
                priority: '',
                cstatus: '',
                icon: '',
                status: ''
            }
        };
    }


    handleSubmit = (values) => {
        this.setState({ spiner: true });
        const { dispatch } = this.props;
        // dispatch(addDepartmentTodo(values)).then(() => this.add_res());

    }


    // add_res = () => {
    //     if (AddDepartmentRes?.success) {
    //         toast.success(AddDepartmentRes?.message, { position: "bottom-right" });
    //         setTimeout(() => {
    //             this.props.history.push('/superadmin/department-list');
    //         }, 1500);
    //         this.setState({ spiner: false });
    //     } else {
    //         toast.error(AddDepartmentRes?.message, { position: "bottom-right" });
    //         this.setState({ spiner: false });
    //     }
    // }
    render() {
        const status_option = [
            { "value": 'Active', "label": "Active" },
            { "value": 'Inactive', "label": "Inactive" }
        ]

        const action_option = [
            { "value": '1', "label": "Yes" },
            { "value": '0', "label": "No" }
        ]

        return (
            <>
                <div className='form_layout'>
                    {this.state.spiner ?
                        <div className='d-flex justify-content-center p-5'>
                            <Loader />
                        </div> :

                        <Formik
                            initialValues={this.state.values}
                            validationSchema={ModuleSchema}
                            onSubmit={this.handleSubmit}
                        >
                            {({
                                values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                                <Form>
                                    <Row>
                                        <Col xl='4'>
                                            <TextInput
                                                label_name='Module Name'
                                                placeholder=''
                                                name='module'
                                                type='text'
                                                value={values.module || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.module && touched.module ? (<span className='text-danger form_label' >{errors.module}</span>) : null}
                                            />
                                        </Col>
                                        <Col xl='4'>
                                            <TextAreaInput
                                                label_name='Description'
                                                placeholder=''
                                                rows={1}
                                                name='description'
                                                type='text'
                                                value={values.description || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.description && touched.description ? (<span className='text-danger form_label' >{errors.description}</span>) : null}
                                            />
                                        </Col>
                                        <Col xl='4'>
                                            <TextInput
                                                label_name='Priority'
                                                placeholder=''
                                                type='number'
                                                name='priority'
                                                value={values.priority || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.priority && touched.priority ? (<span className='text-danger form_label' >{errors.priority}</span>) : null}
                                            />
                                        </Col>
                                        <Col xl='4'>
                                            <TextInput
                                                label_name='Module Icon'
                                                placeholder=''
                                                type='text'
                                                name='icon'
                                                value={values.icon || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.icon && touched.icon ? (<span className='text-danger form_label' >{errors.icon}</span>) : null}
                                            />
                                        </Col>
                                        <Col xl='4'>
                                        <SelectInput
                                                closeMenu={true}
                                                label_name='Single Action'
                                                disabled={false}
                                                options={action_option}
                                                name='cstatus'
                                                defaultValue={''}
                                                onChange={(e) =>
                                                    setFieldValue('cstatus', e.value)
                                                }
                                                onBlur={handleBlur}
                                                error={errors.cstatus && touched.cstatus ? (<span className='text-danger form_label' >{errors.cstatus}</span>) : null} />
                                        </Col>
                                      
                                        <Col xl='4'>
                                            <SelectInput
                                                closeMenu={true}
                                                label_name='Status'
                                                disabled={false}
                                                options={status_option}
                                                name='status'
                                                defaultValue={''}
                                                onChange={(e) =>
                                                    setFieldValue('status', e.value)
                                                }
                                                onBlur={handleBlur}
                                                error={errors.status && touched.status ? (<span className='text-danger form_label' >{errors.status}</span>) : null} />
                                        </Col>
                                     

                                        <Col xl='12' className='d-flex justify-content-end'>
                                            <SaveButton name={'SAVE'} />
                                        </Col>
                                    </Row>
                                </Form>
                            )}
                        </Formik>
                    }
                </div>
                <ToastContainer />
            </>
        )
    }
}
export default connect()(withRouter(AddModuleForm));
